export const data = [
  {
    id: 1,
    msg: `My elderly sister is very sick and I needed to know how to handle her estate. I looked around for an accountant and came across LDA. I asked for advice and they didn't disappoint. They advised me on everything and I appreciate it very much. As an American I was not aware of tax regulations in Canada.`,
    person: "A.C-Senior Citizen",
  },
  {
    id: 2,
    msg: `I have dealt with mostly Tom at LDA, so I can only speak for him. He is not only a great accountant, but a great person as well. I think that is very important, when you need your financial things done well. If you need to deal with a positive, friendly, helpful, attentive, knowledgeable and respectful professional go meet Tom. He genuinely cares for the client.`,
    person: `T.R. "Business Owner" Toronto `,
  },
  {
    id: 3,
    msg: `For me LDA is a highly recommended accounting office with great, trusted, experienced accountants. I have used their services for the last few years and I think they are great.`,
    person: `Gj.H."Business Owner" Toronto`,
  },
  {
    id: 4,
    msg: `Thank you once more for the help. If not for you I would have been paying a lot for interest and penalties.`,
    person: "J.D. - Toronto",
  },
  {
    id: 5,
    msg: `Thank you for preparing and filing my 2005-2015 taxes. My tax owing amount is so much lower than I expected. You did really great. You are my accountant from now on. `,
    person: "J.M - (Mississauga, ON). ",
  },
  {
    id: 6,
    msg: `This is the fourth time that you have prepared my personal and corporate taxes. Good work, Thank you. `,
    person: "E.H. (Business Owner. Scarborough, ON) ",
  },
  {
    id: 7,
    msg: `I've filed my taxes with them for the past 5 years and plan to continue. LDA is great, highly recommend.​`,
    person: "A.C-Senior Citizen",
  },
  {
    id: 8,
    msg: `My elderly sister is very sick and I needed to know how to handle her estate. I looked around for an accountant and came across LDA. I asked for advice and they didn't disappoint. They advised me on everything and I appreciate it very much. As an American I was not aware of tax regulations in Canada.`,
    person: "M.L.-(Toronto, ON) Student.",
  },
]
